<div class="header-search header-search-extended header-search-visible header-search-no-radius d-none d-lg-block">
  <a href="#" class="search-toggle" role="button">
    <i class="icon-search"></i>
  </a>
  <form action="#" method="get"  (click)="showSearchForm($event)" (submit)="submitSearchForm($event)"> <!---->
    <div class="header-search-wrapper search-wrapper-wide">
      <!-- ************** not needed **********************
      <div class="select-custom">
        <select id="cat" name="cat" (change)="onCatSelect($event)">
          <option [value]=null>All Categories</option>
          <option value="women">Women</option>
          <option value="men">Men</option>
          <option value="lighting">Lighting</option>
          <option value="decoration">Decoration</option>
          <option value="electronics">Electronics</option>
          <option value="armchairs-and-chaises">Armchairs & Chaises</option>
          <option value="beds">Beds</option>
          <option value="furniture">Furniture</option>
          <option value="coffee-and-tables">Coffee & Tables</option>
        </select>
      </div>
      -->
      <label for="q" class="sr-only">Search</label>
      <input type="text" class="form-control" name="searchTerm" id="searchTerm" placeholder="Search product ..."
        required (input)="searchProducts($event)" /><!---->
        <button class="btn btn-primary" type="submit">
          <span class="sr-only">Search</span>
          <i class="icon-search"></i>
        </button>
      </div>

      @if (searchTerm.length > 2) {
        <div class="live-search-list">
          @if (suggestions.length > 0) {
            <div class="autocomplete-suggestions" (click)="goProductPage()">
              @for (product of suggestions; track product) {
                <a [routerLink]="'/product/default/' + product.id" class="autocomplete-suggestion"
                  > <!--instead of id it was using slug-->
                  <figure class="mb-0 mr-3 figure-style" >
                    <molla-image [src]="SERVER_URL + product.sm_pictures[0].url" width="40" height="40" alt="Product"
                      class="bg-transparent">
                    </molla-image>
                  </figure>
                  <div class="search-name" [innerHTML]="matchEmphasize(product.name) | safeContent"></div>
                  <span class="search-price">
                    @if (product.minPrice == product.maxPrice) {
                      <div class="product-price mb-0">
                      €{{ product.minPrice.toFixed(2) }}</div>
                    } @else {
                      @if (product.variants.length == 0) {
                        <div class="product-price mb-0">
                          <span class="new-price">€{{ product.minPrice.toFixed(2) }}</span>
                          <span class="old-price">€{{ product.maxPrice.toFixed(2) }}</span>
                        </div>
                      } @else {
                        <div class="product-price mb-0">€{{product.minPrice.toFixed(2)}} -
                        €{{product.maxPrice.toFixed(2)}}</div>
                      }
                    }
                  </span>
                </a>
              }
            </div>
          }
        </div>
      }
    </form>
  </div>